import { ModuleWithProviders, NgModule } from '@angular/core';
import { PipesModule } from '@spaq/shared/pipes.module';
import { SharedCommonModule } from '@spaq/shared/shared-common.module';
import { SharedComponentsModule } from '@spaq/shared/shared-components.module';
import { TranslateModule } from '@ngx-translate/core';
import { GridModule } from '@progress/kendo-angular-grid';
import {
	ParkDetailComponent,
	ParkDetailItemComponent,
	ParkListComponent,
	ParkListDetailsComponent,
	ParksSelectComponent
} from './components';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
	imports: [
		SharedCommonModule,
		GridModule,
		TranslateModule,
		SharedComponentsModule,
		InputsModule,
		ButtonsModule,
		PipesModule,
		SharedComponentsModule,
		SharedCommonModule,
		ComboBoxModule
	],
	declarations: [ParkListComponent, ParkDetailComponent, ParkListDetailsComponent, ParksSelectComponent, ParkDetailItemComponent],
	exports: [ParkListComponent, ParkDetailComponent, ParkListDetailsComponent, ParksSelectComponent]
})
export class ParksModule {
	static forRoot(): ModuleWithProviders<ParksModule> {
		return {
			ngModule: ParksModule,
			providers: []
		};
	}
}
